import { usePostApi } from '@/apiError/apiCreate';
import { ShowAllData, useMutateGetApi } from '@/apiError/apiShow';
import { ShowDataById } from '@/apiError/apiShowById';
import { useUpdateApi } from '@/apiError/apiUpdate';
import '@/assets/style/createCompany.scss';
import { useTransactionContext } from '@/context/TransactionContext';
import { getTodaysDate, getTodaysDateMYD } from '@/utils/date/TodaysDate';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import NewTransactionSubmitModal from '@/utils/modal/NewTransactionSubmitModal';
import { Back } from '@/utils/routerPath/NavigationHelper';
import {
  CenterElement,
  TransactionPurchaseTableHeaderOld as columns,
  TransactionBillColumns,
} from '@/utils/tableHeader';
import { showToast } from '@/utils/toastMessage/ToastMessage';
import {
  Button,
  Card,
  ConfigProvider,
  Form,
  Input,
  InputNumber,
  Select,
  Table,
} from 'antd';
import dayjs from 'dayjs';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import DynamicTransactionTable from '../reuse/DyanamicTransactionTable';
import DynamicTransactionHeader from '../reuse/DynamicHeader';
import {
  calculateTotals,
  CodeGenerateAfterPartySelect,
  processTransactionData,
  renderTransactionTableSummary,
  renderTransactionTableSummaryQP,
  transactionSubmit,
  useBarcodeModal,
} from '../reuse/DynamicTransactionFunctions';
import CashPaidModal from './PurchaseModal';
import { getBsFromAD } from '@/utils/helpers/getTodayDate';
import { useNavigationHistory } from '@/common/navigation-history';
import { returnLinks } from '@/common/navigation-history/data';
import { AntButton } from '@/common/ant-components/AntButton';
import {
  ClearOutlined,
  CloseOutlined,
  DeleteFilled,
  PlusOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import ColumnGroup from 'antd/es/table/ColumnGroup';
import Column from 'antd/es/table/Column';
import CustomSelect from '@/utils/search/Search';
import Cookies from 'js-cookie';
import useAppData from '@/hooks/useAppData';

/**
 * Purchase component for managing purchase transactions.
 * @returns {JSX.Element} Purchase component.
 */

const QuickPurchase = (props) => {
  const {
    setPreviousPath,
    setGlobalDividerTitle,
    purchaseFinalJson,
    setPurchaseFinalJson,
    setPurchaseNetAmount,
    salesSelectedData,
    salesOrderSelectedData,
    selectedData,
    setSelectedData,
    onPurchaseTableDataChange,
    purchaseTableData,
    setpurchaseTableData,
    quickPurchaseTableData,
    setQuickPurchaseTableData,
    editApiBlock,
    setPrefixResponse,
    setShowSalesDescription,
    setSelectedItems,
    selectedItems,
    setEditApiBlock,
    setHiddenValueChange,
    isCancel,
    setModalPurchase,
    record,
    setRecord,
    cashPaidTotal,
    setCashPaidTotal,
    from,
  } = useTransactionContext();

  const {
    barcodeValue,
    barCodeVisible,
    openBarCodeModal,
    closeBarCodeModal,
    filterColumnforBillPrint,
    extraDetails,
    setExtraDetails,
  } = useBarcodeModal(purchaseTableData, TransactionBillColumns);
  const navigate = useNavigate();
  const { id } = useParams();

  const [form] = Form.useForm();
  const [codeInputs, setCodeInputs] = useState([]);

  const [loading, setLoading] = useState('');
  const [showItemList, setShowItemList] = useState();
  const [showPartyList, setShowPartyList] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [paymentVoucherTotal, setPaymentVoucherTotal] = useState(0);

  const primaryCalculationType = Cookies.get('primaryCalculationType');

  const [billNumber, setBillNumber] = useState('');

  const [cashBankLedgerData, setCashBankLedgerData] = useState([]);
  // const [discount, setDiscount] = useState(0);
  const [dataSource, setDataSource] = useState([
    {
      key: 0,
      payFrom: null,
      amount: 0,
      remarks: null,
    },
  ]);

  const { pathname } = useLocation();

  /**
   * Handle input change for various form fields.
   * @param {string} fieldName - Name of the field.
   * @param {any} value - Value of the field.
   * @param {object} option - Additional options.
   */

  const hanldeInputData = (fieldName, value, option) => {
    setSelectedData((prevData) => ({
      ...prevData,
      [fieldName]: value,
      ledgerName: fieldName === 'ledger' ? option : prevData.ledgerName,
    }));
  };

  const updateData = useUpdateApi();

  const { mutateAsync, isPending } = usePostApi({
    url: '/transaction/purchases/',
  });

  const handleUpdateTotal = (updatedTotal) => {
    setPaymentVoucherTotal(updatedTotal);
  };

  const [editMode, setEditMode] = useState(false);
  const [editRowKey, setEditRowKey] = useState(null);

  const selectRefs = useRef([]);
  const selectRef = useRef(null);
  const buttonRef = useRef(null);
  const discountRef = useRef([]);

  /**
   * Handle form submission.
   * Perform validations and save data.
   */

  const handleSubmit = async (values) => {
    const formData = new FormData();
    const { purchaseJson, purchaseVoucherJson } = processTransactionData({
      selectedData,
      dataSource,
      salesSelectedData,
      values,
    });

    const updateCodeWindowJsonResult = transactionSubmit({
      formData,
      jsonName: 'purchaseJson',
      tableData: quickPurchaseTableData,
      firstJson: purchaseJson,
      secondJson: purchaseVoucherJson,
    });

    const purchaseJsonSendToSales = updateCodeWindowJsonResult?.itemDetails;

    const finalJson = {
      purchaseJson,
      itemDetails: purchaseJsonSendToSales,
      voucherJson: dataSource[0]?.payFrom ? purchaseVoucherJson : [],
    };

    if (
      salesSelectedData?.ledgerName ||
      salesSelectedData?.ledger ||
      salesOrderSelectedData?.ledgerName ||
      salesOrderSelectedData?.ledger
    ) {
      const netAmount =
        calculateTotals('amount', quickPurchaseTableData) -
        paymentVoucherTotal -
        (selectedData?.discountAmount ? selectedData?.discountAmount : 0);
      setPurchaseFinalJson(finalJson);
      setPurchaseNetAmount(netAmount);
      setModalPurchase(false);
    }
  };

  /**
   * This function is used for adding the row in the purchase data table
   */

  const handleAddRow = () => {
    onPurchaseTableDataChange({ new: true, id: Date.now()?.toString() });
  };

  /**
   * Handles the selection of an item in the purchase table.
   * Updates the code inputs, selected data, and purchase table data accordingly.
   *
   * @param {string} value - The value of the selected item.
   * @param {number} rowIndex - The index of the row being updated.
   * @param {string} itemName - The name of the selected item.
   */

  const [addRow, selectAddRow] = useState(null);

  useEffect(() => {
    const purchaseTableDataLength = purchaseTableData?.length - 1;
    if (purchaseTableDataLength >= 1) {
      selectRefs.current[purchaseTableDataLength]?.current?.focus();
    } else if (isCancel === 'cancel') {
      selectRefs.current[record?.index]?.current?.focus();
    }
  }, [addRow, selectRefs]);

  const history = useNavigationHistory();
  const target = [...history]
    .reverse()
    .find(
      (path, index) =>
        index === 1 && returnLinks.some((prefix) => path.startsWith(prefix)),
    );

  const { app } = useAppData();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        if (!id && !editApiBlock) {
          const response = await ShowAllData.showDetails(
            '/transaction/purchases/latest-bill-number/',
          );
          setBillNumber(response);
          setSelectedData((prev) => ({
            ...prev,
            purchaseBillNumber: response?.billNumber,
            // entryDate: getTodaysDate(),
            entryDate:
              app?.financialEndYear &&
              new Date(getTodaysDateMYD()) > new Date(app?.financialEndYear)
                ? dayjs(app?.financialEndYear)
                : getTodaysDate(),
          }));
          setGlobalDividerTitle('Create Purchase');
          setPreviousPath('/purchase-modal/create/');
        }
        fetchItemList();
        fetchPartyList();
        setShowSalesDescription(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const fetchItemList = async () => {
    const itemResponse = await ShowAllData.showDetails(
      '/account/inventory/items/',
    );
    setShowItemList(itemResponse.data);
  };

  const fetchPartyList = async () => {
    const partyListResponse = await ShowAllData.showDetails(
      '/account/ledgers/purchase-receive/',
    );
    setShowPartyList(partyListResponse.data);
  };

  /**
   * Custom hook to set form fields from selected data.
   */

  useEffect(() => {
    const fetchSelectedData = () => {
      form.setFieldsValue({
        ...selectedData,
        purchaseBillNumber: selectedData?.purchaseBillNumber,
        entry_date_bs: getBsFromAD(selectedData?.entryDate),
      });
      if (salesSelectedData.ledger != '') {
        form.setFieldsValue({
          ledger: salesSelectedData.ledger,
        });
      }
    };
    fetchSelectedData();
  }, [selectedData]);

  /**
   * Calculate the total amount for a specific key in the purchase table data.
   *
   * @param {string} key - The key to sum up.
   * @returns {number} The total amount calculated.
   */

  const handleVoucherFetchApiClicked = async () => {
    const ledgerData = await ShowAllData.showDetails(
      '/vouchers/payment-ledgers/',
    );
    const isLedgerValid =
      ledgerData?.data?.paidToLedger?.length > 0 &&
      ledgerData?.data?.paidToLedger?.some(
        (item) => item.referenceId === selectedData?.ledger,
      );
    if (!isLedgerValid) {
      showToast('The party is not opened on Sundry Debtors.', 'warn');
      return;
    }
    setModalVisible(true);
    setCashBankLedgerData(ledgerData?.data);
  };

  const handleKeyDown = useCallback((e) => {
    if (e.code === 'F10') {
      e.preventDefault();
      form?.submit();
    }
    if (e.code === 'KeyJ' && e.altKey && selectedData?.ledger !== '') {
      e.preventDefault();
      handleVoucherFetchApiClicked();
    }
  }, []);

  useEffect(() => {
    window.removeEventListener('keydown', handleKeyDown);
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  const partyNameWatch = Form.useWatch('ledger', form);

  const paymentTotal = paymentVoucherTotal || cashPaidTotal;

  const { mutateAsync: mutateGoldApi, isPending: loadingGoldRate } =
    useMutateGetApi();

  const getGoldRate = async (itemType) => {
    // const data = await ShowAllData.showDetails('transaction/gold-rates/');
    const data = await mutateGoldApi({ url: '/transaction/gold-rates/' });

    if (
      data?.data?.goldRate &&
      Object.keys(data.data?.goldRate?.goldRate)?.length > 0
    ) {
      let rate = data?.data?.goldRate;
      const newRate =
        itemType === 'Gold'
          ? rate?.goldRate
          : itemType === 'Silver'
            ? rate?.silverRate
            : 0;

      form.setFieldsValue({ rate: newRate, calculationType: 'goldrate' });
    }
  };

  const focusNode = (key) => {
    const inputInstance = form?.getFieldInstance(key);
    if (inputInstance) {
      inputInstance?.focus();
    }
  };

  const addRowRef = useRef(null);
  const clearRef = useRef(null);
  const headerSelectRef = useRef(null);

  useEffect(() => {
    requestAnimationFrame(() => {
      headerSelectRef.current?.focus();
    });
  }, []);

  const handleWastageWeight = () => {
    let wastageWeight = Number(form.getFieldValue('wastageWeight')) || 0;
    if (form.getFieldValue('wastageType') === 'gw') {
      wastageWeight =
        (form.getFieldValue('grossWeight') *
          Number(form.getFieldValue('wastageCharge'))) /
        100;
    } else if (form.getFieldValue('wastageType') === 'nw') {
      wastageWeight =
        (form.getFieldValue('netWeight') *
          Number(form.getFieldValue('wastageCharge'))) /
        100;
    } else if (form.getFieldValue('wastageType') === 'pw') {
      wastageWeight =
        (form.getFieldValue('pureWeight') *
          Number(form.getFieldValue('wastageCharge'))) /
        100;
    } else if (form.getFieldValue('wastageType') === 'w') {
      wastageWeight = Number(form.getFieldValue('wastageCharge'));
    }

    form.setFieldsValue({
      wastageWeight: wastageWeight.toFixed(
        primaryCalculationType === 'lal' ? 1 : 3,
      ),
    });
    return wastageWeight;
  };

  const handleNetAmount = () => {
    const netWeight = Number(
      (Number(form?.getFieldValue('grossWeight')) || 0).toFixed(3),
    );

    const wastageWeight = handleWastageWeight();

    const netWithWastage = Number(
      (netWeight + Number(wastageWeight || 0)).toFixed(3),
    );

    const calculateRate = Number(
      (
        Number(form.getFieldValue('purity') / 100) *
          Number(form.getFieldValue('rate')) || 0
      ).toFixed(3),
    );

    const netAmount =
      Number(
        Number(
          netWithWastage.toFixed(primaryCalculationType === 'lal' ? 1 : 3) *
            calculateRate,
        ).toFixed(3),
      ) || 0;

    form.setFieldsValue({
      amount: netAmount?.toFixed(3),
    });
  };

  // const columns = [
  //   {
  //     dataIndex: 'item',
  //     key: 'item',
  //     title: <div className="tw-text-sm">Item</div>,
  //     width: 100,
  //     header: () => (
  //       <Form.Item name={`item`} noStyle rules={[{ required: true }]}>
  //         <CustomSelect
  //           style={{ width: '100%' }}
  //           selectRef={headerSelectRef}
  //           placeholder="Select Item"
  //           onSelect={async (value, option) => {
  //             form.setFieldValue('item', option?.itemName);
  //             const prefixResponse = await ShowAllData?.showDetails(
  //               `transaction/order-items/latest-code/?itemId=${value}`,
  //             );
  //             form.setFieldsValue({
  //               ...prefixResponse?.data,
  //             });
  //             getGoldRate(prefixResponse?.data?.itemType);
  //             focusNode('rate');
  //           }}
  //           options={showItemList?.map((item) => ({
  //             key: item.referenceId,
  //             label: item.name,
  //             value: item.referenceId,
  //             itemName: item.name,
  //           }))}
  //           filterSort={() => {}}
  //         />
  //       </Form.Item>
  //     ),
  //   },

  //   {
  //     dataIndex: 'itemCode',
  //     key: 'itemCode',
  //     title: 'Code',
  //     width: 100,
  //     align: 'center',
  //     header: () => (
  //       <Form.Item name={`itemCode`} noStyle rules={[{ required: true }]}>
  //         <Input readOnly />
  //       </Form.Item>
  //     ),
  //   },

  //   {
  //     dataIndex: 'rate',
  //     key: 'rate',
  //     title: 'Rate',
  //     width: 100,
  //     align: 'right',
  //     header: () => (
  //       <Form.Item name={`rate`} noStyle rules={[{ required: true }]}>
  //         <Input
  //           onChange={() => {
  //             handleNetAmount();
  //           }}
  //           onPressEnter={(e) => {
  //             e.preventDefault();
  //             form.validateFields(['rate']).then((values) => {
  //               if (values.rate) {
  //                 focusNode('grossWeight');
  //               }
  //             });
  //           }}
  //         />
  //       </Form.Item>
  //     ),
  //   },

  //   {
  //     dataIndex: 'grossWeight',
  //     key: 'grossWeight',
  //     title: 'Gross Wt.',
  //     width: 100,
  //     align: 'right',
  //     header: () => (
  //       <Form.Item name={`grossWeight`} noStyle rules={[{ required: true }]}>
  //         <Input
  //           onChange={() => {
  //             handleNetAmount();
  //           }}
  //           onPressEnter={(e) => {
  //             e.preventDefault();
  //             form.validateFields(['grossWeight']).then((values) => {
  //               focusNode('purity');
  //             });
  //           }}
  //         />
  //       </Form.Item>
  //     ),
  //   },

  //   {
  //     dataIndex: 'purity',
  //     key: 'purity',
  //     title: 'Purity',
  //     width: 100,
  //     align: 'right',
  //     header: () => (
  //       <Form.Item
  //         name={`purity`}
  //         noStyle
  //         initialValue={100}
  //         rules={[{ required: true }]}
  //       >
  //         <InputNumber
  //           controls={false}
  //           max={100}
  //           onChange={() => {
  //             handleNetAmount();
  //           }}
  //           onPressEnter={(e) => {
  //             e.preventDefault();
  //             form.validateFields(['purity']).then((values) => {
  //               focusNode('wastageType');
  //             });
  //           }}
  //           addonAfter={
  //             <Form.Item noStyle initialValue={'%'} name={'purityType'}>
  //               <Select
  //                 popupMatchSelectWidth={false}
  //                 style={{
  //                   width: 48,
  //                 }}
  //               >
  //                 <Option value="%">%</Option>
  //                 <Option value="crt">Crt</Option>
  //               </Select>
  //             </Form.Item>
  //           }
  //         />
  //       </Form.Item>
  //     ),
  //   },

  //   {
  //     dataIndex: 'wastageType',
  //     key: 'wastageType',
  //     title: 'Wstg. Type',
  //     width: 100,
  //     align: 'center',
  //     header: () => (
  //       <Form.Item name={`wastageType`} noStyle>
  //         <Select
  //           style={{
  //             width: '100%',
  //           }}
  //           showSearch
  //           onSelect={() => {
  //             handleNetAmount();
  //             focusNode('wastageCharge');
  //           }}
  //         >
  //           <Option value="w">W</Option>
  //           <Option value="gw">Gw</Option>
  //           <Option value="nw">Nw</Option>
  //           <Option value="pw">Pw</Option>
  //         </Select>
  //       </Form.Item>
  //     ),
  //   },

  //   {
  //     dataIndex: 'wastageCharge',
  //     key: 'wastageCharge',
  //     title: 'Wstg. Charge',
  //     align: 'right',
  //     width: 100,
  //     header: () => (
  //       <Form.Item
  //         name={`wastageCharge`}
  //         initialValue={0}
  //         noStyle
  //         rules={[{ required: true }]}
  //       >
  //         <Input
  //           onChange={(e) => {
  //             const val = e.target.value ?? 0;
  //             handleNetAmount();
  //             form.setFieldsValue({
  //               fineWeight: form.getFieldValue('pureWeight') ?? 0 - val,
  //             });
  //           }}
  //           onPressEnter={(e) => {
  //             e.preventDefault();
  //             focusNode('pureWeight');
  //           }}
  //         />
  //       </Form.Item>
  //     ),
  //   },

  //   {
  //     dataIndex: 'pureWeight',
  //     key: 'pureWeight',
  //     title: 'Pure Wt.',
  //     align: 'right',

  //     width: 100,
  //     header: () => (
  //       <Form.Item name={`pureWeight`} noStyle rules={[{ required: true }]}>
  //         <Input
  //           onChange={(e) => {
  //             const val = e.target.value ?? 0;
  //             handleNetAmount();
  //             form.setFieldsValue({
  //               fineWeight: val - form.getFieldValue('wastageCharge') ?? 0,
  //             });
  //           }}
  //           onPressEnter={(e) => {
  //             e.preventDefault();
  //             focusNode('fineWeight');
  //           }}
  //         />
  //       </Form.Item>
  //     ),
  //   },

  //   {
  //     dataIndex: 'fineWeight',
  //     key: 'fineWeight',
  //     title: 'Fine Wt.',
  //     align: 'right',

  //     width: 100,
  //     header: () => (
  //       <Form.Item name={`fineWeight`} noStyle rules={[{ required: true }]}>
  //         <Input
  //           onPressEnter={(e) => {
  //             e.preventDefault();
  //             focusNode('amount');
  //           }}
  //         />
  //       </Form.Item>
  //     ),
  //   },

  //   {
  //     dataIndex: 'amount',
  //     key: 'amount',
  //     title: 'Amount',
  //     align: 'right',

  //     width: 100,
  //     header: () => (
  //       <Form.Item name={`amount`} noStyle rules={[{ required: true }]}>
  //         <Input
  //           readOnly
  //           onPressEnter={(e) => {
  //             e.preventDefault();
  //             addRowRef?.current?.focus();
  //           }}
  //         />
  //       </Form.Item>
  //     ),
  //   },
  //   {
  //     dataIndex: 'action',
  //     key: 'action',
  //     title: 'Action',
  //     align: 'center',
  //     render: (_, record) => (
  //       <div className="tw-flex tw-justify-center">
  //         <div
  //           className="ant-action tw-flex"
  //           onClick={(e) => e.stopPropagation()}
  //         >
  //           <div className="ant-button-delete" onClick={() => {}}>
  //             <Link size="medium" className="delete">
  //               <DeleteFilled
  //                 onClick={() => {
  //                   const filteredData = quickPurchaseTableData?.filter(
  //                     (item) => item?.itemCode !== record?.itemCode,
  //                   );
  //                   setQuickPurchaseTableData(filteredData);
  //                 }}
  //               />
  //             </Link>
  //           </div>
  //         </div>
  //       </div>
  //     ),

  //     width: 15,
  //     header: () => (
  //       <div className="tw-flex tw-items-center tw-justify-center tw-gap-x-2">
  //         <AntButton
  //           type="default"
  //           shape="circle"
  //           onClick={() => {
  //             form.validateFields().then((values) => {
  //               setQuickPurchaseTableData([...quickPurchaseTableData, values]);
  //               form.resetFields([
  //                 'item',
  //                 'itemCode',
  //                 'rate',
  //                 'purity',
  //                 'grossWeight',
  //                 'wastageType',
  //                 'wastageWeight',
  //                 'pureWeight',
  //                 'fineWeight',
  //                 'amount',
  //                 'wastageCharge',
  //               ]);
  //               headerSelectRef?.current?.focus();
  //             });
  //           }}
  //           icon={<PlusOutlined className="tw-ms-1" />}
  //           ref={addRowRef}
  //         />
  //         <AntButton
  //           shape="circle"
  //           type="default"
  //           ref={clearRef}
  //           icon={<ClearOutlined className="tw-ms-1" />}
  //         />
  //       </div>
  //     ),
  //   },
  // ];

  const columns = [
    {
      dataIndex: 'item',
      key: 'item',
      title: <div className="tw-text-sm">Item</div>,
      width: 100,
      header: () => (
        <Form.Item name={`item`} noStyle rules={[{ required: true }]}>
          <CustomSelect
            style={{ width: '100%' }}
            selectRef={headerSelectRef}
            placeholder="Select Item"
            selectLoading={loadingGoldRate}
            onSelect={async (value, option) => {
              form.setFieldValue('item', option?.itemName);
              const prefixResponse = await ShowAllData?.showDetails(
                `transaction/order-items/latest-code/?itemId=${value}`,
              );
              form.setFieldsValue({ ...prefixResponse?.data });
              getGoldRate(prefixResponse?.data?.itemType);
              focusNode('rate');
            }}
            options={showItemList?.map((item) => ({
              key: item.referenceId,
              label: item.name,
              value: item.referenceId,
              itemName: item.name,
            }))}
            filterSort={() => {}}
          />
        </Form.Item>
      ),
    },
    {
      dataIndex: 'itemCode',
      key: 'itemCode',
      title: <div className="tw-text-sm">Code</div>,
      width: 100,
      align: 'center',
      header: () => (
        <Form.Item name={`itemCode`} noStyle rules={[{ required: true }]}>
          <Input readOnly />
        </Form.Item>
      ),
    },
    {
      dataIndex: 'rate',
      key: 'rate',
      title: <div className="tw-text-sm">Rate</div>,
      width: 100,
      align: 'right',
      header: () => (
        <Form.Item name={`rate`} noStyle rules={[{ required: true }]}>
          <Input
            onChange={handleNetAmount}
            onPressEnter={(e) => {
              e.preventDefault();
              form.validateFields(['rate']).then((values) => {
                if (values.rate) focusNode('grossWeight');
              });
            }}
          />
        </Form.Item>
      ),
    },
    {
      dataIndex: 'grossWeight',
      key: 'grossWeight',
      title: <div className="tw-text-sm">Gross Wt.</div>,
      width: 100,
      align: 'right',
      header: () => (
        <Form.Item name={`grossWeight`} noStyle rules={[{ required: true }]}>
          <Input
            onChange={handleNetAmount}
            onPressEnter={(e) => {
              e.preventDefault();
              form.validateFields(['grossWeight']).then(() => {
                focusNode('purity');
              });
            }}
          />
        </Form.Item>
      ),
    },
    {
      dataIndex: 'purity',
      key: 'purity',
      title: <div className="tw-text-sm">Purity</div>,
      width: 100,
      align: 'right',
      header: () => (
        <Form.Item
          name={`purity`}
          noStyle
          initialValue={100}
          rules={[{ required: true }]}
        >
          <InputNumber
            controls={false}
            maxLength={3}
            onChange={handleNetAmount}
            onPressEnter={(e) => {
              e.preventDefault();
              form.validateFields(['purity']).then(() => {
                focusNode('wastageType');
              });
            }}
            addonAfter={
              <Form.Item noStyle initialValue={'%'} name={'purityType'}>
                <Select popupMatchSelectWidth={false} style={{ width: 48 }}>
                  <Option value="%">%</Option>
                  <Option value="crt">Crt</Option>
                </Select>
              </Form.Item>
            }
          />
        </Form.Item>
      ),
    },
    {
      dataIndex: 'wastageType',
      key: 'wastageType',
      title: <div className="tw-text-sm">Wstg. Type</div>,
      width: 100,
      align: 'center',
      header: () => (
        <Form.Item name={`wastageType`} noStyle>
          <Select
            style={{ width: '100%' }}
            showSearch
            onSelect={() => {
              handleNetAmount();
              focusNode('wastageCharge');
            }}
          >
            <Option value="w">W</Option>
            <Option value="gw">Gw</Option>
            <Option value="nw">Nw</Option>
            <Option value="pw">Pw</Option>
          </Select>
        </Form.Item>
      ),
    },
    {
      dataIndex: 'wastageCharge',
      key: 'wastageCharge',
      title: <div className="tw-text-sm">Wstg.</div>,
      align: 'right',
      width: 100,
      header: () => (
        <Form.Item
          name={`wastageCharge`}
          initialValue={0}
          noStyle
          rules={[{ required: true }]}
        >
          <Input
            onChange={(e) => {
              const val = e.target.value ?? 0;
              handleNetAmount();
              form.setFieldsValue({
                fineWeight: form.getFieldValue('pureWeight') ?? 0 - val,
              });
            }}
            onPressEnter={(e) => {
              e.preventDefault();
              focusNode('pureWeight');
            }}
          />
        </Form.Item>
      ),
    },
    {
      dataIndex: 'pureWeight',
      key: 'pureWeight',
      title: <div className="tw-text-sm">Pure Wt.</div>,
      align: 'right',
      width: 100,
      header: () => (
        <Form.Item name={`pureWeight`} noStyle rules={[{ required: true }]}>
          <Input
            onChange={(e) => {
              const val = e.target.value ?? 0;
              handleNetAmount();
              form.setFieldsValue({
                fineWeight: val - form.getFieldValue('wastageCharge') ?? 0,
              });
            }}
            onPressEnter={(e) => {
              e.preventDefault();
              focusNode('fineWeight');
            }}
          />
        </Form.Item>
      ),
    },
    {
      dataIndex: 'fineWeight',
      key: 'fineWeight',
      title: <div className="tw-text-sm">Fine Wt.</div>,
      align: 'right',
      width: 100,
      header: () => (
        <Form.Item name={`fineWeight`} noStyle rules={[{ required: true }]}>
          <Input
            onPressEnter={(e) => {
              e.preventDefault();
              focusNode('amount');
            }}
          />
        </Form.Item>
      ),
    },
    {
      dataIndex: 'amount',
      key: 'amount',
      title: <div className="tw-text-sm">Amount</div>,
      align: 'right',
      width: 100,
      header: () => (
        <Form.Item name={`amount`} noStyle rules={[{ required: true }]}>
          <Input
            readOnly
            onPressEnter={(e) => {
              e.preventDefault();
              addRowRef?.current?.focus();
            }}
          />
        </Form.Item>
      ),
    },
    {
      dataIndex: 'action',
      key: 'action',
      title: <div className="tw-text-sm">Action</div>,
      align: 'center',
      width: 15,
      render: (_, record) => (
        <div className="tw-flex tw-justify-center">
          <div
            className="ant-action tw-flex"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ant-button-delete" onClick={() => {}}>
              <Link size="medium" className="delete">
                <DeleteFilled
                  onClick={() => {
                    const filteredData = quickPurchaseTableData?.filter(
                      (item) => item?.id !== record?.id,
                    );
                    setQuickPurchaseTableData(filteredData);
                  }}
                />
              </Link>
            </div>
          </div>
        </div>
      ),
      header: () => (
        <div className="tw-flex tw-items-center tw-justify-center tw-gap-x-2">
          <AntButton
            type="default"
            shape="circle"
            onClick={() => {
              form
                .validateFields()
                .then((values) => {
                  if (editMode && editRowKey) {
                    const updatedData = quickPurchaseTableData.map((item) =>
                      item.id === editRowKey ? { ...item, ...values } : item,
                    );
                    setQuickPurchaseTableData(updatedData);
                    setEditMode(false);
                    setEditRowKey(null);
                  } else {
                    const newItem = {
                      ...values,
                      id: `${Date.now()}-${Math.random()}`,
                    };
                    setQuickPurchaseTableData([
                      ...quickPurchaseTableData,
                      newItem,
                    ]);
                    // form.resetFields([
                    //   'item',
                    //   'itemCode',
                    //   'rate',
                    //   'purity',
                    //   'grossWeight',
                    //   'wastageType',
                    //   'wastageWeight',
                    //   'pureWeight',
                    //   'fineWeight',
                    //   'amount',
                    //   'wastageCharge',
                    // ]);
                    requestAnimationFrame(() => {
                      headerSelectRef?.current?.focus();
                    });
                  }
                })
                .catch(({ errorFields }) => {
                  if (errorFields.length > 0) {
                    const firstErrorFieldKey = errorFields[0]?.name?.[0];
                    if (firstErrorFieldKey === 'item') {
                      headerSelectRef?.current?.focus();
                    } else {
                      focusNode(firstErrorFieldKey);
                    }
                  }
                });
            }}
            icon={<PlusOutlined className="tw-ms-1" />}
            ref={addRowRef}
          />
          <AntButton
            shape="circle"
            type="default"
            ref={clearRef}
            onClick={() => {
              form.resetFields([
                'item',
                'itemCode',
                'rate',
                'purity',
                'grossWeight',
                'wastageType',
                'wastageWeight',
                'pureWeight',
                'fineWeight',
                'amount',
                'wastageCharge',
              ]);
              requestAnimationFrame(() => {
                headerSelectRef?.current?.focus();
              });
            }}
            icon={<ClearOutlined className="tw-ms-1" />}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <>
        <Form
          form={form}
          onFinish={handleSubmit}
          onValuesChange={(changedValues, values) => {
            if (changedValues) {
              setHiddenValueChange(true);
            }
          }}
          scrollToFirstError={{
            focus: true,
          }}
        >
          <DynamicTransactionHeader
            hanldeInputData={hanldeInputData}
            showPartyList={showPartyList}
            from={'quickpurchase'}
            noPadding
            billNumber={billNumber}
            selectedData={selectedData}
            refreshTable={fetchPartyList}
            form={form}
            selectRefs={selectRefs}
            selectRef={selectRef}
            isFromQuickPurchase
          />
          {/* <div>
            <DynamicTransactionTable
              loading={loading}
              columns={columns}
              selectRefs={selectRefs}
              selectRef={selectRef}
              from={'purchase'}
              // tableData={Array(10).fill(purchaseTableData[0])}
              tableData={purchaseTableData}
              handleAddRow={handleAddRow}
              handleItemSelect={handleItemSelect}
              renderSummary={renderTransactionTableSummary(purchaseTableData)}
              showItemList={showItemList}
              baseUrl="codewindow-modal"
              editUrl={'transaction/purchase-modal/edit'}
              handlePurchaseItemClick={handlePurchaseItemClick}
              refreshTable={fetchItemList}
              form={form}
              discountRef={discountRef}
              showDisabledData={true}
            />
          </div> */}

          <ConfigProvider
            theme={{
              components: {
                Table: {
                  cellPaddingInline: 2,
                  cellPaddingBlock: 2,
                  headerColor: '#ffffff',
                  fontWeightStrong: 500,

                  // fontSize: 12,
                  borderColor: '#12a36cc2',
                },
              },
            }}
          >
            <Table
              dataSource={quickPurchaseTableData}
              bordered
              rowClassName={() => 'tw-cursor-pointer'}
              summary={() =>
                renderTransactionTableSummaryQP(quickPurchaseTableData)
              }
              onRow={(record) => {
                return {
                  onDoubleClick: () => {
                    setEditMode(true);
                    setEditRowKey(record.id);
                    form.setFieldsValue({
                      ...record,
                    });
                    focusNode('rate');
                  },
                  style: {
                    backgroundColor:
                      editRowKey === record.id ? '#d2d2d2' : 'white',
                  },
                };
              }}
              rowHoverable
            >
              {columns?.map((col) => (
                <ColumnGroup title={col.header}>
                  <Column
                    title={col.title}
                    width={col.width}
                    dataIndex={col.dataIndex}
                    key={col.key}
                    align={col.align}
                    render={col.render}
                  />
                </ColumnGroup>
              ))}
            </Table>
          </ConfigProvider>
          <div>
            <div>
              <div className="tw-mt-[10px]">
                <Form.Item label="Remarks" name="remarks">
                  <Input.TextArea
                    placeholder="Enter Remarks"
                    rows={1}
                    className="tw-w-[200px] md:tw-w-[250px] lg:tw-w-[500px] 2xl:tw-w-[500px]"
                  />
                </Form.Item>
              </div>
              {/* </div> */}

              {!(from === 'sales' || from === 'sales-order') && (
                <div>
                  <>
                    <div className="tw-flex tw-gap-x-2">
                      <AntButton
                        type="primary"
                        onClick={() => {
                          handleVoucherFetchApiClicked();
                        }}
                        disabled={
                          from === 'sales' || from === 'sales-order'
                            ? true
                            : pathname === '/purchase/create/'
                              ? !partyNameWatch
                              : !!id
                        }
                      >
                        Payment [Alt + J]
                      </AntButton>
                      {id && billNumber?.voucherNumber && (
                        <div className="tw-px-3 tw-py-[5px] tw-rounded-lg tw-bg-green-50 tw-border tw-border-green-200 tw-text-green-800 tw-shadow-sm tw-text-sm">
                          <span className="tw-font-medium">Payment:</span>{' '}
                          <span className="tw-font-semibold">
                            Rs.{' '}
                            {billNumber?.voucherAmount?.toLocaleString() || 0}
                          </span>{' '}
                          made using voucher{' '}
                          <span className="tw-italic">
                            {billNumber?.voucherNumber}
                          </span>
                          .
                        </div>
                      )}
                    </div>
                    <p
                      style={{
                        marginTop: '10px',
                        fontSize: '16px',
                        color: 'red',
                      }}
                    >
                      {from === 'sales'
                        ? 'Note: Please complete purchase and you will be back to sales after you will save this purchase'
                        : from === 'sales-order'
                          ? 'Note: Please complete purchase and you will be back to sales order after you will save this purchase'
                          : ''}
                    </p>
                  </>
                </div>
              )}
            </div>

            <div className="tw-flex tw-justify-end">
              <div>
                <Card>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end',
                      gap: '4px',
                      borderRadius: '8px',
                      width: '300px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div
                        style={{
                          fontWeight: 500,
                          color: '#5c5c5c',
                          fontSize: 14,
                        }}
                      >
                        Sub Total:
                      </div>
                      <div>
                        <strong>
                          {calculateTotals(
                            'amount',
                            quickPurchaseTableData,
                          ).toLocaleString()}
                        </strong>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                      }}
                      className="transaction-table-calculation-list"
                    >
                      <div
                        style={{
                          fontWeight: 500,
                          color: '#5c5c5c',
                          fontSize: 14,
                        }}
                      >
                        Discount:
                      </div>
                      <div>
                        <InputNumber
                          ref={discountRef}
                          value={selectedData?.discountAmount}
                          onChange={(value) =>
                            setSelectedData((prev) => ({
                              ...prev,
                              discountAmount: value,
                            }))
                          }
                          onPressEnter={(e) => {
                            e.preventDefault();
                            buttonRef.current?.focus();
                          }}
                          controls={false}
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                      }}
                      className="transaction-table-calculation-list"
                    >
                      <div
                        style={{
                          fontWeight: 500,
                          color: '#5c5c5c',
                          fontSize: 14,
                        }}
                      >
                        Grand Total:
                      </div>
                      <div>
                        <strong>
                          {(
                            calculateTotals('amount', quickPurchaseTableData) -
                            paymentTotal -
                            (selectedData?.discountAmount
                              ? selectedData?.discountAmount
                              : 0)
                          ).toLocaleString()}
                        </strong>
                      </div>
                    </div>
                  </div>
                </Card>
                <div className="tw-flex tw-justify-end tw-py-[10px]">
                  <div className="tw-flex tw-gap-x-3">
                    <AntButton
                      color="green"
                      htmlType="submit"
                      icon={<SaveOutlined />}
                    >
                      Save [F10]
                    </AntButton>
                    <AntButton
                      onClick={() => {
                        setModalPurchase(false);
                      }}
                      icon={<CloseOutlined />}
                      color="red"
                    >
                      Cancel
                    </AntButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
        <CashPaidModal
          visible={modalVisible}
          onClose={() => setModalVisible(false)}
          onTotalUpdate={handleUpdateTotal}
          selectedData={selectedData}
          billNumber={billNumber}
          dataSource={dataSource}
          setDataSource={setDataSource}
          cashBankLedgerData={cashBankLedgerData}
          refreshTable={handleVoucherFetchApiClicked}
        />
        <NewTransactionSubmitModal
          visible={barCodeVisible}
          onClose={() => {
            if (target) {
              const apiEditCall = target?.includes('/sales/edit/');
              apiEditCall && setEditApiBlock(false);
              closeBarCodeModal();
            } else {
              navigate('/purchase/list/');
            }
          }}
          onSave={handleSubmit}
          barcodeValues={barcodeValue}
          tableData={purchaseTableData?.map((row) => ({
            ...row,
            itemCode: row.code || row.itemCode,
            netWithWastage:
              row.netWithWastage || row?.summaryData?.netWithWastage,
          }))}
          columns={filterColumnforBillPrint}
          title={'Purchase'}
          party={
            showPartyList?.find(
              (item) => item.referenceId === selectedData?.ledger,
            )?.name || selectedData?.ledgerName
          }
          billNumber={selectedData?.billNumber || selectedData?.billNo}
          voucherNumber={selectedData?.entryNumber}
          date={form?.getFieldValue('entryDate')?.format('YYYY-MM-DD')}
          from="transaction"
          extraDetails={extraDetails}
          setExtraDetails={setExtraDetails}
        />
      </>
    </>
  );
};

export default QuickPurchase;
